import merge from "lodash/merge";
import api from "./api";
import config from "../config";

export default {
  fetchOne(apiKey, externalSync) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `external_syncs/${externalSync}`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchAllForBucket(apiKey, bucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${bucket}/external_syncs`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.external_syncs);
        }
      );
    });
  },

  edit(apiKey, externalSync, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `external_syncs/${externalSync}`,
          json: values,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  forceSync(apiKey, externalSync) {
    let debug = false;

    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `external_syncs/${externalSync}/force_sync`,
          json: { debug: debug },
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  delete(apiKey, externalSync) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "DELETE",
          endpoint: `external_syncs/${externalSync}`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  create(apiKey, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `external_syncs`,
          json: values,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  getProviderStatus(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `external_syncs/provider_status`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  getMailchimpSegmentsForList(apiKey, list) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `external_syncs/provider_status/mailchimp_segments`,
          qs: { list: list },
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/ExternalSyncUtil.js